import { SvgCalendarGradient } from '@chilipiper/icons/src/apps'
import {
  SvgMeet,
  SvgMicrosoftTeams,
} from '@chilipiper/icons/src/design-system/3rd-party-integrations'

const GOOGLE_MEET = {
  name: 'Google Meet',
  icon: SvgMeet,
}

const MICROSOFT_TEAMS = {
  name: 'Microsoft Teams',
  icon: SvgMicrosoftTeams,
}

export const getCalendarLocationInfo = (
  calendar: 'GoogleCalendar' | 'MicrosoftOutlook' | undefined
) => {
  if (calendar === 'GoogleCalendar') {
    return {
      icon: GOOGLE_MEET.icon,
      name: GOOGLE_MEET.name,
    }
  }

  if (calendar === 'MicrosoftOutlook') {
    return {
      icon: MICROSOFT_TEAMS.icon,
      name: MICROSOFT_TEAMS.name,
    }
  }

  return {
    icon: SvgCalendarGradient,
    name: 'Calendar',
  }
}
